import React from 'react'

export const Hit = ({
  color = '#1C1C1E',
  size,
  className
}: {
  color?: string
  size: number
  className?: string
}) => {
  return size === 8 ? (
    <svg
      width='8'
      height='9'
      viewBox='0 0 8 9'
      fill='none'
      className={className ?? ''}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.99998 8.5C4.13214 8.5 4.22872 8.40335 4.25414 8.26604C4.61499 5.48408 5.00633 5.0569 7.76111 4.75176C7.90341 4.73649 8 4.63476 8 4.49744C8 4.36521 7.90341 4.26352 7.76111 4.24825C5.00633 3.94311 4.61499 3.51589 4.25414 0.72886C4.22872 0.591541 4.13214 0.5 3.99998 0.5C3.86783 0.5 3.77129 0.591541 3.75094 0.72886C3.39009 3.51589 2.99364 3.94311 0.243964 4.24825C0.0965665 4.26352 0 4.36521 0 4.49744C0 4.63476 0.0965665 4.73649 0.243964 4.75176C2.98856 5.11284 3.36975 5.48408 3.75094 8.26604C3.77129 8.40335 3.86783 8.5 3.99998 8.5Z'
        fill={color}
      />
    </svg>
  ) : (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      className={className ?? ''}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.49997 13C6.71472 13 6.87168 12.8429 6.91298 12.6198C7.49936 8.09912 8.13529 7.40496 12.6118 6.90911C12.843 6.88429 13 6.71898 13 6.49585C13 6.28096 12.843 6.11573 12.6118 6.0909C8.13529 5.59505 7.49936 4.90082 6.91298 0.371898C6.87168 0.148755 6.71472 0 6.49997 0C6.28522 0 6.12834 0.148755 6.09528 0.371898C5.5089 4.90082 4.86466 5.59505 0.396442 6.0909C0.156921 6.11573 0 6.28096 0 6.49585C0 6.71898 0.156921 6.88429 0.396442 6.90911C4.85641 7.49587 5.47585 8.09912 6.09528 12.6198C6.12834 12.8429 6.28522 13 6.49997 13Z'
        fill={color}
      />
    </svg>
  )
}
